var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Circle } from "react-native-svg";
var SvgActive = function SvgActive(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 14"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#0CEB66"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 7,
    cy: 7,
    r: 5
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 7,
    cy: 7,
    r: 7,
    fillOpacity: 0.5
  }))));
};
export default SvgActive;